// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
// Bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// Medsurf Lib
import { FlatDesignModule } from '@medsurf/flat-designs';
import { MedsurfCommonModule } from '../common/medsurf-common.module';
// Components
import { SearchComponent } from './search.component';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    // Bootstrap
    NgbModule,
    // Translate
    TranslateModule.forChild(),
    // Modules
    MedsurfCommonModule,
    FlatDesignModule
  ],
  declarations: [
    // Components
    SearchComponent
  ],
})
export class SearchModule {
}
